/* eslint max-len: 0 */
import React from 'react';

export const Lot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M1.99999 20H1.98999C4.74999 17.23 9.21999 17.23 11.99 19.99"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.01001 15V18" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.64999 7.09002L3.14999 9.58002H3.13999C2.93999 9.77002 2.93999 10.09 3.13999 10.28C3.22999 10.37 3.35999 10.42 3.48999 10.42H8.47999H8.46999C8.73999 10.41 8.95999 10.19 8.95999 9.91002C8.94999 9.77002 8.89999 9.65002 8.80999 9.55002L6.30999 7.05002C6.10999 6.85002 5.78999 6.85002 5.59999 7.04002L5.64999 7.09002Z"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21 16V4H18V5.66" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 16V12H17.5V16" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 16H13" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 7.333L16 4L22 9" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.05999 10.44L2.15999 13.86V13.85C1.90999 14.13 1.94999 14.57 2.23999 14.81C2.35999 14.91 2.50999 14.97 2.67999 14.97H9.29999H9.28999C9.65999 14.96 9.96999 14.66 9.96999 14.28C9.95999 14.11 9.90999 13.96 9.79999 13.83L6.89999 10.4"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
